import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { EmailInputComponent } from '../../../../shared/ui/email-input';
import { ChangePasswordStore } from '../store/change-password.store';
import { SuccessDialogComponent } from '../../users-management/components/success-dialog/success-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translationPipe';

@Component({
  selector: 'app-reset-forgotten-password',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatInputModule,
    ReactiveFormsModule,
    EmailInputComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 class="title">{{ 'resetPassword' | translate | async }}</h2>
    <p class="subtitle">
      {{ 'forgotPasswordInstructions' | translate | async }}
    </p>
    <form
      [formGroup]="store.forgotPasswordForm"
      (ngSubmit)="store.submitForgotPassword(dialogRef)"
      class="form"
    >
      <app-email-input [form]="store.forgotPasswordForm" controlName="email" />
      <div class="actions">
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="store.forgotPasswordForm.invalid"
          class="confirm-button"
        >
          {{ 'submit' | translate | async }}
        </button>
      </div>
    </form>
  `,
  styles: `
    @use "spacing/spacing-variables" as *;

    .form {
      width: 500px;
    } 
    .title {
      text-align: center;
      font-size: 24px;
      font-weight: var(--mat-sys-regular-font-weight);
      color: var(--mat-sys-on-surface-variant);
      margin-bottom: $spacing-sm;
    } 
    .subtitle {
      text-align: center;
      font-size: 16px;
      font-weight: var(--mat-sys-medium-font-weight);
      color: var(--mat-sys-on-surface-variant);
      margin-bottom: $spacing-2xl;
      margin-top: $spacing-none;
   }
  `,
})
export class ResetForgottenPasswordComponent {
  readonly store = inject(ChangePasswordStore);
  readonly dialogRef = inject(MatDialogRef<SuccessDialogComponent>);
}
